/* Price experiment v1: separate QA/live assignments; base prices and cart properties unchanged. */
(function(root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.LumlyPricingPreview = api;
    root.LumlyPricingReady = api.assign(root.LumlyPricingQAConfig, root.location.search,
      {getItem:k=>root.localStorage.getItem(k),setItem:(k,v)=>root.localStorage.setItem(k,v)},
      async function(visitorId) {
        const controller = new AbortController();
        const timer = setTimeout(()=>controller.abort(),2000);
        try {
          const response = await fetch('https://customify-s56o.vercel.app/api/pricing-assignment', {
            method:'POST',headers:{'Content-Type':'application/json'},signal:controller.signal,
            body:JSON.stringify({visitorId,mode:'live'})
          });
          if (!response.ok) throw Error('Assignment unavailable');
          return (await response.json()).group;
        } finally { clearTimeout(timer); }
      }, ()=>crypto.randomUUID(),
      root.navigator?.locks ? fn=>root.navigator.locks.request('lumly-pricing-live-v1-assignment',fn) : fn=>fn()
    ).then(group=>{ root.LumlyPricingQAGroup=group; return group; });
  }
})(typeof window === 'object' ? window : globalThis, function() {
  'use strict';
  const key = 'lumly-pricing-qa-v1';
  const liveKey = 'lumly-pricing-live-v1';
  function choose(config, search, storage, random) {
    if (!config || config.eligible === false) return 'A';
    if (config.themeRole === 'main') {
      if (config.liveEnabled !== true) return 'A';
      try {
        const prior = storage.getItem(liveKey);
        if (prior === 'A' || prior === 'B') return prior;
        return 'A'; // New live assignments require the shared allocator below.
      } catch (_) { return 'A'; }
    }
    if (!['unpublished', 'development'].includes(config.themeRole)) return 'A';
    const params = new URLSearchParams(search);
    try {
      if (params.get('pricing_qa') === '0') {
        storage.setItem(key + '-enabled', '0');
        return 'A';
      }
      if (params.get('pricing_qa') === '1') storage.setItem(key + '-enabled', '1');
      if (storage.getItem(key + '-enabled') !== '1') return 'A';
      const forced = params.get('pricing_group');
      if (forced === 'A' || forced === 'B') {
        storage.setItem(key, forced);
        return forced;
      }
      const prior = storage.getItem(key);
      if (prior === 'A' || prior === 'B') return prior;
      const group = random() < 0.5 ? 'A' : 'B';
      storage.setItem(key, group);
      return group;
    } catch (_) { return 'A'; }
  }
  async function assign(config, search, storage, request, makeId, exclusive=fn=>fn()) {
    if (!config || config.eligible === false || config.themeRole !== 'main' || config.liveEnabled !== true)
      return choose(config,search,storage,Math.random);
    function fallback() {
      // Keep a stable price during outages, but exclude this browser from the experiment.
      try {
        const prior=storage.getItem(liveKey);
        if (prior==='A'||prior==='B') return prior;
        storage.setItem(liveKey+'-excluded','1'); storage.setItem(liveKey,'A');
      } catch (_) {}
      return 'A';
    }
    async function once() {
      try {
        const prior=storage.getItem(liveKey);
        if (prior==='A'||prior==='B') return prior;
        let visitorId=storage.getItem(liveKey+'-visitor');
        if (!visitorId) { visitorId=makeId(); storage.setItem(liveKey+'-visitor',visitorId); }
        const group=await request(visitorId);
        if (group!=='A'&&group!=='B') throw Error('Invalid assignment');
        // A concurrent tab may have established a price while the request was in flight.
        const latest=storage.getItem(liveKey);
        if (latest==='A'||latest==='B') return latest;
        storage.setItem(liveKey,group);
        return group;
      } catch (_) { return fallback(); }
    }
    try {
      const prior=storage.getItem(liveKey);
      if (prior==='A'||prior==='B') return prior;
      return await exclusive(once);
    } catch (_) { return fallback(); }
  }
  function apply(app, group) {
    if (app.pricingPreviewGroup) return; // immutable for this page instance
    app.pricingPreviewGroup = group === 'B' ? 'B' : 'A';
    if (app.pricingPreviewGroup !== 'B') return;
    app.sizePricing = {...app.sizePricing,
      plakat: {a4:0,a3:5,a2:20,a0:30,a1:40},
      spotify_frame: {a4:0,a3:5,a2:20,a0:30,a1:40},
      canvas: {a4:40,a3:70,a2:100,a0:120,a1:160},
      szklo: {a5:0,a4:20}};
    app.framePricing = {a4:19,a3:35,a2:69,a0:79,a1:89};
    app.canvasFramePricing = {a4:59,a3:89,a2:119,a0:149,a1:179};
    app.standPricing = {none:0,wood:19,led:29.90};
  }
  function giftPrice(group) { return group === 'B' ? 19 : 29; }
  let lastOffer = null;
  let offerTimer;
  let exposed = false;
  function tracking() {
    try {
      if (typeof window === 'undefined' || !window.LumlyPricingQAConfig || window.LumlyPricingQAConfig.eligible === false) return null;
      const cfg = window.LumlyPricingQAConfig;
      const live = cfg.themeRole === 'main' && cfg.liveEnabled === true;
      if (!live && (!['unpublished','development'].includes(cfg.themeRole) || localStorage.getItem(key + '-enabled') !== '1')) return null;
      const activeKey = live ? liveKey : key;
      if (live && localStorage.getItem(liveKey+'-excluded') === '1') return null;
      const group = localStorage.getItem(activeKey);
      if (!['A','B'].includes(group) || group !== window.LumlyPricingQAGroup) return null;
      let visitorId = localStorage.getItem(activeKey + '-visitor');
      if (!visitorId) { visitorId = crypto.randomUUID(); localStorage.setItem(activeKey + '-visitor', visitorId); }
      return {visitorId,group,mode:live?'live':'qa'};
    } catch (_) { return null; }
  }
  function track(metric, offer) {
    const identity = tracking();
    if (!identity) return;
    try {
      const selected = offer || JSON.parse(sessionStorage.getItem((identity.mode === 'live' ? liveKey : key) + '-last-offer') || 'null');
      if (!selected) return;
      fetch('https://customify-s56o.vercel.app/api/pricing-event', {
        method:'POST',headers:{'Content-Type':'application/json'},keepalive:true,
        body:JSON.stringify({...identity,metric,eventId:crypto.randomUUID(),snapshot:selected})
      }).catch(function() {});
    } catch (_) {}
  }
  function capture(app, finalPrice) {
    const identity = tracking();
    if (!identity) return;
    try {
      const type = app.selectedProductType;
      const offer = {handle:app.getProductHandle(),type,
        size:type === 'digital' ? 'digital' : type === 'etui' ? 'etui' : app.selectedSize,
        frame:window.CustomifyFrame?.color || 'none',stand:window.CustomifyStand?.type || 'none',
        gift:app.isGiftPackagingSelected(),priceCents:Math.round(finalPrice * 100)};
      if (type !== 'plakat' && type !== 'canvas') offer.frame = 'none';
      if (type !== 'szklo') offer.stand = 'none';
      const serialized = JSON.stringify(offer);
      sessionStorage.setItem((identity.mode === 'live' ? liveKey : key) + '-last-offer', serialized);
      if (!exposed) { exposed = true; track('exposure',offer); }
      if (serialized === lastOffer) return;
      lastOffer = serialized;
      clearTimeout(offerTimer);
      offerTimer = setTimeout(function(){ track('offer',offer); },500);
    } catch (_) {}
  }
  return {choose, assign, apply, giftPrice, tracking, track, capture};
});
